import React from 'react'

import { Box, BoxProps, CloseButton, Group } from '@mantine/core'
import cn from 'classnames'

import { LaunchToastProps } from './types'

import styles from './Toast.module.scss'

export type ToastComponentProps = Omit<BoxProps, 'className'> &
  Pick<
    LaunchToastProps,
    'icon' | 'type' | 'dismissable' | 'onDismiss' | 'message' | 'children'
  >

export function Toast(props: ToastComponentProps) {
  const {
    icon,
    type = 'neutral',
    dismissable = true,
    onDismiss,
    message,
    children,
    ...otherProps
  } = props

  const [dismissed, setIsDismissed] = React.useState(false)

  const handleDismiss = () => {
    setIsDismissed(true)
    if (onDismiss) onDismiss()
  }

  if (dismissed) return null

  const classNames = cn(styles.toast, styles[`toast___${type}`])

  return (
    <Box {...otherProps} className={classNames}>
      <div className={styles.toast_message}>
        {icon && (
          <div className={styles.toast_icon}>
            <i className={icon}></i>
          </div>
        )}
        {message}
      </div>
      <Group wrap="nowrap">
        <div className={styles.toast_action}>{children}</div>
        {dismissable && (
          <CloseButton
            className={styles.toast_button}
            onClick={handleDismiss}
            variant="transparent"
          ></CloseButton>
        )}
      </Group>
    </Box>
  )
}
